import { getEnv, getEnvPublic, isLocalDevelopmentEnvironment, isProductionEnvironment } from "@remi/environment";

/**
 * Determine the Sentry environment string based on Node/Next and Vercel env vars.
 */
export function getSentryEnvironment(): "production" | "preview" | "development" {
  if (isProductionEnvironment()) {
    return "production";
  }
  if (isLocalDevelopmentEnvironment()) {
    return "development";
  }
  return "preview";
}

const isLocalScript = () => {
  return typeof window === "undefined" && getEnv("LOCAL_SCRIPT") === "true";
};

/**
 * Whether Sentry should be enabled for the resolved environment.
 */
export function isSentryEnabled(): boolean {
  const nextForceEnabled = getEnvPublic("NEXT_PUBLIC_FORCE_ENABLE_SENTRY");
  const expoForceEnabled = getEnvPublic("EXPO_PUBLIC_FORCE_ENABLE_SENTRY");

  const forceEnabled = nextForceEnabled || expoForceEnabled;
  if (forceEnabled) {
    return true;
  }

  return isProductionEnvironment() && !isLocalScript();
}
